import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/Api/axiosV2Config';

export interface AvailableWarranty {
  companyContractId: number;
  name: string;
  duration: number;
  kmLimit: number;
  financialCap: number;
  partsCount: number;
  sellingPrice: number;
  isMensualisable: boolean;
  isCashPayment: boolean;
  isSold: boolean;
}

/**
 * Hook pour récupérer les garanties disponibles pour une attestation
 */
export const useAvailableWarranties = (deliveryProofId: string | null) => {
  return useQuery({
    queryKey: ['delivery-proof-warranties', deliveryProofId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<AvailableWarranty[]>(
        `/pro-v2/delivery-proofs/${deliveryProofId}/available-warranties`
      );
      return data;
    },
    enabled: !!deliveryProofId,
    staleTime: 60000, // 1 minute
  });
};
